const list = [
  {
    bundle: 'preBoarding',
    name: 'Pre-Boarding',
  },
  {
    bundle: 'boarding',
    name: 'Boarding',
  },
];

export default list;
